export default __webpack_public_path__ + "static/media/profile.9e4745a2.png";